var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export { RestrictionType } from './Throttling/RestrictionType';
export default function (context) {
    context.registerService({
        name: 'IStoredCommandManager',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "StoredCommandManager" */ './Commands/StoredCommandManager');
            return new svc.StoredCommandManager(context);
        })
    });
    context.registerService({
        name: 'ICityManager',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "CityManager" */ './Misc/CityManager');
            return new svc.CityManager(context);
        })
    });
    context.registerService({
        name: 'IRegionManager',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "RegionManager" */ './Misc/RegionManager');
            return new svc.RegionManager(context);
        })
    });
    context.registerService({
        name: 'IServiceManager',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "ServiceManager" */ './Misc/ServiceManager');
            return new svc.ServiceManager(context);
        })
    });
    context.registerService({
        name: 'ICountryDatabaseManager',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "CountryDatabaseManager" */ './Throttling/CountryDatabaseManager');
            return new svc.CountryDatabaseManager(context);
        })
    });
    context.registerService({
        name: 'IRestrictionQueryService',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "RestrictionQueryService" */ './Throttling/RestrictionQueryService');
            return new svc.RestrictionQueryService(context);
        })
    });
    context.registerService({
        name: 'IThrottleManager',
        activator: () => __awaiter(this, void 0, void 0, function* () {
            var svc = yield import(/* webpackChunkName: "ThrottleManager" */ './Throttling/ThrottleManager');
            return new svc.ThrottleManager(context);
        })
    });
}
//# sourceMappingURL=main.js.map